<template>
  <h3 v-if="getAppliedDeliveryFee" class="text-body-1"
    >Delivery Fee : ${{ roundToFixed(getAppliedDeliveryFee / 100) }}</h3
  >
</template>

<script>
import { mapGetters } from 'vuex'
import roundToFixed from '@/utils/roundToFixed'

export default {
  name: 'CartDeliveryFee',
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters('cart', ['getAppliedDeliveryFee']),
  },
  methods: {
    roundToFixed,
  },
}
</script>
